import { ReactNode, useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';

import useAuth from '@hooks/useAuth';

import AuthenticatedLayout from './authenticatedLayout/AuthenticatedLayout';
import GuestLayout from './guestLayout/GuestLayout';

interface BackLink {
  title: string;
  to: string;
}

export interface LayoutProps {
  title?: ReactNode | string;
  loading?: boolean;
  backLink?: BackLink;
  rightSection?: ReactNode;
}

type SetLayoutProps = (props: LayoutProps) => void;

export interface LayoutContextType {
  setLayoutProps: SetLayoutProps;
}

export default function Layout() {
  const { isAuthenticated } = useAuth();

  const [title, setTitle] = useState<ReactNode | string>();
  const [loading, setLoading] = useState<boolean>();
  const [backLink, setBackLink] = useState<BackLink>();
  const [rightSection, setRightSection] = useState<ReactNode>();

  const setLayoutProps = useCallback<SetLayoutProps>(
    (props) => {
      setTitle(props.title);
      setLoading(props.loading);
      setBackLink(props.backLink);
      setRightSection(props.rightSection);
    },
    [setTitle, setLoading, setBackLink, setRightSection],
  );

  return isAuthenticated ? (
    <AuthenticatedLayout
      title={title}
      loading={loading}
      backLink={backLink}
      rightSection={rightSection}
    >
      <Outlet context={{ setLayoutProps } satisfies LayoutContextType} />
    </AuthenticatedLayout>
  ) : (
    <GuestLayout>
      <Outlet />
    </GuestLayout>
  );
}
